import { RESTRICTED_PLANS } from 'app/constants';
import { LaunchChangePlanServiceModule } from './launchChangePlan.service';
import { TrialServiceModule } from '../../components/trial/trial.service';
import './changePlanButton.scss';

export const ChangePlanButtonModule = angular
    .module('app.components.changePlan.changePlanButton', [
        LaunchChangePlanServiceModule,
        TrialServiceModule
    ]).component('changePlanButton', {
        template: `
            <md-button
                class="md-accent md-raised md-button--has-icon-left"
                ng-if="$ctrl.allowPlanChange"
                ng-click="$ctrl.openChangePlanModal($event)">
                <md-icon
                    aria-label="Change Plan Button"
                    class="material-plus"
                    md-svg-src="//d3ggqrmoaaez04.cloudfront.net/images/logos/logo_symbol_light.svg">
                </md-icon>
                <span>{{'CHANGEPLAN.CHANGEPLAN' | translate}}</span>
            </md-button>
        `,
        controller: class ChangePlanButtonCtrl {
            constructor(launchChangePlanService, trialService) {
                'ngInject';

                angular.extend(this, {
                    launchChangePlanService,
                    trialService,
                    allowPlanChange: false
                });
            }

            $onInit() {
                this.trialService.getSubscription().then((subscription) => {
                    this.allowPlanChange = !RESTRICTED_PLANS.includes(subscription.plan.id);
                });
            }

            openChangePlanModal(event) {
                this.launchChangePlanService.openModal(event);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/changePlan/changePlanButton.js